!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("react")) : "function" == typeof define && define.amd ? define("Bloomer", ["react"], r) : "object" == typeof exports ? exports.Bloomer = r(require("react")) : e.Bloomer = r(e.React);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    function r(a) {
      if (t[a]) return t[a].exports;
      var s = t[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }

    var t = {};
    return r.m = e, r.c = t, r.d = function (e, t, a) {
      r.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: a
      });
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, r.p = "", r(r.s = 6);
  }([function (e, r, t) {
    "use strict";

    function a(e, r) {
      function t() {
        this.constructor = e;
      }

      _N(e, r), e.prototype = null === r ? Object.create(r) : (t.prototype = r.prototype, new t());
    }

    function s(e, r) {
      var t = {};

      for (var a in e) {
        Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (t[a] = e[a]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) for (var s = 0, a = Object.getOwnPropertySymbols(e); s < a.length; s++) {
        r.indexOf(a[s]) < 0 && (t[a[s]] = e[a[s]]);
      }
      return t;
    }

    function i(e, r, t, a) {
      var s,
          i = arguments.length,
          n = i < 3 ? r : null === a ? a = Object.getOwnPropertyDescriptor(r, t) : a;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(e, r, t, a);else for (var o = e.length - 1; o >= 0; o--) {
        (s = e[o]) && (n = (i < 3 ? s(n) : i > 3 ? s(r, t, n) : s(r, t)) || n);
      }
      return i > 3 && n && Object.defineProperty(r, t, n), n;
    }

    function n(e, r) {
      return function (t, a) {
        r(t, a, e);
      };
    }

    function o(e, r) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, r);
    }

    function l(e, r, t, a) {
      return new (t || (t = Promise))(function (s, i) {
        function n(e) {
          try {
            l(a.next(e));
          } catch (e) {
            i(e);
          }
        }

        function o(e) {
          try {
            l(a.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function l(e) {
          e.done ? s(e.value) : new t(function (r) {
            r(e.value);
          }).then(n, o);
        }

        l((a = a.apply(e, r || [])).next());
      });
    }

    function u(e, r) {
      function t(e) {
        return function (r) {
          return a([e, r]);
        };
      }

      function a(t) {
        if (s) throw new TypeError("Generator is already executing.");

        for (; l;) {
          try {
            if (s = 1, i && (n = 2 & t[0] ? i.return : t[0] ? i.throw || ((n = i.return) && n.call(i), 0) : i.next) && !(n = n.call(i, t[1])).done) return n;

            switch (i = 0, n && (t = [2 & t[0], n.value]), t[0]) {
              case 0:
              case 1:
                n = t;
                break;

              case 4:
                return l.label++, {
                  value: t[1],
                  done: !1
                };

              case 5:
                l.label++, i = t[1], t = [0];
                continue;

              case 7:
                t = l.ops.pop(), l.trys.pop();
                continue;

              default:
                if (n = l.trys, !(n = n.length > 0 && n[n.length - 1]) && (6 === t[0] || 2 === t[0])) {
                  l = 0;
                  continue;
                }

                if (3 === t[0] && (!n || t[1] > n[0] && t[1] < n[3])) {
                  l.label = t[1];
                  break;
                }

                if (6 === t[0] && l.label < n[1]) {
                  l.label = n[1], n = t;
                  break;
                }

                if (n && l.label < n[2]) {
                  l.label = n[2], l.ops.push(t);
                  break;
                }

                n[2] && l.ops.pop(), l.trys.pop();
                continue;
            }

            t = r.call(e, l);
          } catch (e) {
            t = [6, e], i = 0;
          } finally {
            s = n = 0;
          }
        }

        if (5 & t[0]) throw t[1];
        return {
          value: t[0] ? t[1] : void 0,
          done: !0
        };
      }

      var s,
          i,
          n,
          o,
          l = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: t(0),
        throw: t(1),
        return: t(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;
    }

    function d(e, r) {
      for (var t in e) {
        r.hasOwnProperty(t) || (r[t] = e[t]);
      }
    }

    function c(e) {
      var r = "function" == typeof Symbol && e[Symbol.iterator],
          t = 0;
      return r ? r.call(e) : {
        next: function next() {
          return e && t >= e.length && (e = void 0), {
            value: e && e[t++],
            done: !e
          };
        }
      };
    }

    function f(e, r) {
      var t = "function" == typeof Symbol && e[Symbol.iterator];
      if (!t) return e;
      var a,
          s,
          i = t.call(e),
          n = [];

      try {
        for (; (void 0 === r || r-- > 0) && !(a = i.next()).done;) {
          n.push(a.value);
        }
      } catch (e) {
        s = {
          error: e
        };
      } finally {
        try {
          a && !a.done && (t = i.return) && t.call(i);
        } finally {
          if (s) throw s.error;
        }
      }

      return n;
    }

    function v() {
      for (var e = [], r = 0; r < arguments.length; r++) {
        e = e.concat(f(arguments[r]));
      }

      return e;
    }

    function _(e) {
      return this instanceof _ ? (this.v = e, this) : new _(e);
    }

    function g(e, r, t) {
      function a(e) {
        d[e] && (u[e] = function (r) {
          return new Promise(function (t, a) {
            c.push([e, r, t, a]) > 1 || s(e, r);
          });
        });
      }

      function s(e, r) {
        try {
          i(d[e](r));
        } catch (e) {
          l(c[0][3], e);
        }
      }

      function i(e) {
        e.value instanceof _ ? Promise.resolve(e.value.v).then(n, o) : l(c[0][2], e);
      }

      function n(e) {
        s("next", e);
      }

      function o(e) {
        s("throw", e);
      }

      function l(e, r) {
        e(r), c.shift(), c.length && s(c[0][0], c[0][1]);
      }

      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var u,
          d = t.apply(e, r || []),
          c = [];
      return u = {}, a("next"), a("throw"), a("return"), u[Symbol.asyncIterator] = function () {
        return this;
      }, u;
    }

    function m(e) {
      function r(r, s) {
        t[r] = e[r] ? function (t) {
          return (a = !a) ? {
            value: _(e[r](t)),
            done: "return" === r
          } : s ? s(t) : t;
        } : s;
      }

      var t, a;
      return t = {}, r("next"), r("throw", function (e) {
        throw e;
      }), r("return"), t[Symbol.iterator] = function () {
        return this;
      }, t;
    }

    function p(e) {
      function r(r) {
        a[r] = e[r] && function (a) {
          return new Promise(function (s, i) {
            a = e[r](a), t(s, i, a.done, a.value);
          });
        };
      }

      function t(e, r, t, a) {
        Promise.resolve(a).then(function (r) {
          e({
            value: r,
            done: t
          });
        }, r);
      }

      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var a,
          s = e[Symbol.asyncIterator];
      return s ? s.call(e) : (e = "function" == typeof c ? c(e) : e[Symbol.iterator](), a = {}, r("next"), r("throw"), r("return"), a[Symbol.asyncIterator] = function () {
        return this;
      }, a);
    }

    function M(e, r) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: r
      }) : e.raw = r, e;
    }

    function b(e) {
      if (e && e.__esModule) return e;
      var r = {};
      if (null != e) for (var t in e) {
        Object.hasOwnProperty.call(e, t) && (r[t] = e[t]);
      }
      return r.default = e, r;
    }

    function h(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), r.__extends = a, t.d(r, "__assign", function () {
      return _P;
    }), r.__rest = s, r.__decorate = i, r.__param = n, r.__metadata = o, r.__awaiter = l, r.__generator = u, r.__exportStar = d, r.__values = c, r.__read = f, r.__spread = v, r.__await = _, r.__asyncGenerator = g, r.__asyncDelegator = m, r.__asyncValues = p, r.__makeTemplateObject = M, r.__importStar = b, r.__importDefault = h;
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _N = function N(e, r) {
      return (_N = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, r) {
        e.__proto__ = r;
      } || function (e, r) {
        for (var t in r) {
          r.hasOwnProperty(t) && (e[t] = r[t]);
        }
      })(e, r);
    },
        _P = function P() {
      return _P = Object.assign || function (e) {
        for (var r, t = 1, a = arguments.length; t < a; t++) {
          r = arguments[t];

          for (var s in r) {
            Object.prototype.hasOwnProperty.call(r, s) && (e[s] = r[s]);
          }
        }

        return e;
      }, _P.apply(this, arguments);
    };
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r,
          t = e.isAlign;
      return F(t) ? (r = {}, r["is-" + t] = !0, r) : {};
    }

    function s(e) {
      e.isAlign;
      return j.__rest(e, ["isAlign"]);
    }

    function i(e) {
      var r,
          t = e.isSize;
      return k(t) ? (r = {}, r["is-" + t] = !0, r) : {};
    }

    function n(e) {
      e.isSize;
      return j.__rest(e, ["isSize"]);
    }

    function o(e) {
      return {
        "is-fullwidth": e.isFullWidth
      };
    }

    function l(e) {
      e.isFullWidth;
      return j.__rest(e, ["isFullWidth"]);
    }

    function u(e) {
      return {
        "is-active": e.isActive
      };
    }

    function d(e) {
      e.isActive;
      return j.__rest(e, ["isActive"]);
    }

    function c(e) {
      return {
        "is-focused": e.isFocused
      };
    }

    function f(e) {
      e.isFocused;
      return j.__rest(e, ["isFocused"]);
    }

    function v(e) {
      return {
        "is-hovered": e.isHovered
      };
    }

    function _(e) {
      e.isHovered;
      return j.__rest(e, ["isHovered"]);
    }

    function g(e) {
      return j.__assign({}, u(e), c(e), v(e));
    }

    function m(e) {
      e.isActive, e.isFocused, e.isHovered;
      return j.__rest(e, ["isActive", "isFocused", "isHovered"]);
    }

    function p(e) {
      return {
        "is-loading": e.isLoading
      };
    }

    function M(e) {
      e.isLoading;
      return j.__rest(e, ["isLoading"]);
    }

    function b(e) {
      var r,
          t = e.isColor;
      return t ? (r = {}, r["is-" + t] = !0, r) : {};
    }

    function h(e) {
      e.isColor;
      return j.__rest(e, ["isColor"]);
    }

    function N(e) {
      var r,
          t = e.isSpaced,
          a = e.isSize,
          s = I(a) ? (r = {}, r["is-" + a] = !0, r) : {};
      return j.__assign({}, s, {
        "is-spaced": t
      });
    }

    function P(e) {
      e.isSize, e.isSpaced;
      return j.__rest(e, ["isSize", "isSpaced"]);
    }

    function y(e) {
      var r = e.isDisplay,
          t = e.isHidden,
          a = e.isPulled,
          s = e.isClearfix,
          i = e.isOverlay,
          n = e.isMarginless,
          o = e.isPaddingless,
          l = e.isUnselectable,
          u = e.hasTextAlign,
          d = e.hasTextColor;
      return j.__assign({}, U(r), J(t), K(a, "is-pulled"), K(u, "has-text"), Q(d), {
        "is-clearfix": s,
        "is-marginless": n,
        "is-overlay": i,
        "is-paddingless": o,
        "is-unselectable": l
      });
    }

    function H(e) {
      e.isDisplay, e.isHidden, e.isClearfix, e.isPulled, e.isOverlay, e.isMarginless, e.isPaddingless, e.isUnselectable, e.hasTextAlign, e.hasTextColor;
      return j.__rest(e, ["isDisplay", "isHidden", "isClearfix", "isPulled", "isOverlay", "isMarginless", "isPaddingless", "isUnselectable", "hasTextAlign", "hasTextColor"]);
    }

    function w(e) {
      return e.displayName || e.name;
    }

    function O(e) {
      var r = function r(_r) {
        var t = E(j.__assign({}, T.combineModifiers(_r, y, o)), _r.className),
            a = T.getHTMLProps(_r, H, l);
        return t ? S.createElement(e, j.__assign({}, a, {
          className: t
        })) : S.createElement(e, j.__assign({}, a));
      };

      return r.displayName = "withHelpersModifiers(" + w(e) + ")", r;
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var j = t(0),
        E = t(3),
        S = t(2),
        T = t(4);
    r.isMobile = T.is({
      mobile: !0
    }), r.isTablet = T.is({
      tablet: !0
    }), r.isTouch = T.is({
      touch: !0
    }), r.isDesktop = T.is({
      desktop: !0
    }), r.isWidescreen = T.is({
      widescreen: !0
    }), r.isFullHD = T.is({
      fullhd: !0
    });
    var L = T.is({
      "tablet-only": !0
    }),
        C = T.is({
      "desktop-only": !0
    });
    r.isLeft = T.is({
      left: !0
    }), r.isRight = T.is({
      right: !0
    }), r.isCentered = T.is({
      centered: !0
    }), r.isCenter = T.is({
      center: !0
    }), r.isFullWidth = T.is({
      fullwidth: !0
    });
    var x = T.is({
      small: !0
    }),
        A = T.is({
      medium: !0
    }),
        z = T.is({
      large: !0
    }),
        B = T.isOption(r.isMobile, r.isTablet, r.isDesktop, r.isTouch, r.isWidescreen, L, C),
        F = T.isOption(r.isLeft, r.isCentered, r.isRight),
        k = T.isOption(x, A, z);
    r.getAlignmentModifiers = a, r.removeAlignmentProps = s, r.getSizeModifiers = i, r.removeSizeProps = n, r.getActiveModifiers = u, r.removeActiveModifiers = d, r.getFocusedModifiers = c, r.removeFocusedModifiers = f, r.getHoveredModifiers = v, r.removeHoveredModifiers = _, r.getStateModifiers = g, r.removeStateProps = m, r.getLoadingModifiers = p, r.removeLoadingProps = M, r.getColorModifiers = b, r.removeColorProps = h;
    var I = T.isBetween(1, 6);
    r.getHeadingModifiers = N, r.removeHeadingProps = P;

    var D = T.is({
      flex: !0
    }),
        R = T.is({
      block: !0
    }),
        G = T.is({
      inline: !0
    }),
        W = T.is({
      "inline-block": !0
    }),
        V = T.is({
      "inline-flex": !0
    }),
        q = T.isOption(D, R, G, W, V),
        U = function U(e) {
      var r,
          t = function t(e) {
        return "default" === e;
      };

      return "string" == typeof e ? (r = {}, r["is-" + e] = !0, r) : Array.isArray(e) ? e.reduce(function (e, r) {
        var t;
        return j.__assign({}, e, (t = {}, t["is-" + r] = !0, t));
      }, {}) : "object" == typeof e ? Object.keys(e).reduce(function (r, a) {
        var s, i;
        return Array.isArray(e[a]) ? e[a].reduce(function (e, r) {
          var s, i;
          return t(r) ? j.__assign({}, e, (s = {}, s["is-" + a] = !0, s)) : j.__assign({}, e, (i = {}, i["is-" + a + "-" + r] = !0, i));
        }, r) : t(e[a]) ? j.__assign({}, r, (s = {}, s["is-" + a] = !0, s)) : q(a) && B(e[a]) ? j.__assign({}, r, (i = {}, i["is-" + a + "-" + e[a]] = !0, i)) : r;
      }, {}) : {};
    },
        J = function J(e) {
      var r;
      return "boolean" == typeof e ? e ? {
        "is-hidden": !0
      } : {} : "string" == typeof e ? B(e) ? (r = {}, r["is-hidden-" + e] = !0, r) : {} : Array.isArray(e) ? e.reduce(function (e, r) {
        var t;
        return B(r) ? j.__assign({}, e, (t = {}, t["is-hidden-" + r] = !0, t)) : e;
      }, {}) : {};
    },
        K = function K(e, r) {
      var t;
      return F(e) ? (t = {}, t[r + "-" + e] = !0, t) : {};
    },
        Q = function Q(e) {
      var r;
      return e ? (r = {}, r["has-text-" + e] = !0, r) : {};
    };

    r.withHelpersModifiers = O;
  }, function (r, t) {
    r.exports = e;
  }, function (e, r, t) {
    var a, s;
    /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      function t() {
        for (var e = [], r = 0; r < arguments.length; r++) {
          var a = arguments[r];

          if (a) {
            var s = typeof a;
            if ("string" === s || "number" === s) e.push(a);else if (Array.isArray(a) && a.length) {
              var n = t.apply(null, a);
              n && e.push(n);
            } else if ("object" === s) for (var o in a) {
              i.call(a, o) && a[o] && e.push(o);
            }
          }
        }

        return e.join(" ");
      }

      var i = {}.hasOwnProperty;
      void 0 !== e && e.exports ? (t.default = t, e.exports = t) : (a = [], void 0 !== (s = function () {
        return t;
      }.apply(r, a)) && (e.exports = s));
    }();
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      for (var r = [], t = 1; t < arguments.length; t++) {
        r[t - 1] = arguments[t];
      }

      return r.length > 0 ? r.reduce(function (e, r) {
        return i.__assign({}, r(e));
      }, e) : e;
    }

    function s(e) {
      for (var r = [], t = 1; t < arguments.length; t++) {
        r[t - 1] = arguments[t];
      }

      return r.length > 0 ? r.reduce(function (r, t) {
        return i.__assign({}, r, t(e));
      }, {}) : {};
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var i = t(0);
    r.getHTMLProps = a, r.combineModifiers = s, r.isBetween = function (e, r) {
      return function (t) {
        return t >= e && t <= r;
      };
    }, r.is = function (e) {
      return function (r) {
        return e[r] || !1;
      };
    }, r.isOption = function () {
      for (var e = [], r = 0; r < arguments.length; r++) {
        e[r] = arguments[r];
      }

      return function (r) {
        return e.some(function (e) {
          return e(r);
        });
      };
    };
  }, function (e, r, t) {
    "use strict";

    function a(e, r, t) {
      void 0 === r && (r = !1), void 0 === t && (t = !1);
      var a;
      return Number.isInteger(e) && g(e) ? (a = {}, a["is-" + (r ? "offset-" : "") + e + (m(t) ? "-" + t : "")] = !0, a) : {};
    }

    function s(e) {
      e.isSize;
      return f.__rest(e, ["isSize"]);
    }

    function i(e, r, t) {
      var a,
          s = r ? p : f.__assign({}, p, M);
      return s[e] ? (a = {}, a["is-" + (r ? "offset-" : "") + s[e] + (m(t) ? "-" + t : "")] = !0, a) : {};
    }

    function n(e, r) {
      return Object.keys(e).reduce(function (t, a) {
        return "default" === a ? f.__assign({}, t, o(e[a], r)) : m(a) ? f.__assign({}, t, o(e[a], r, a)) : t;
      }, {});
    }

    function o(e, r, t) {
      return void 0 === r && (r = !1), void 0 === t && (t = !1), "number" == typeof e ? a(e, r, t) : "string" == typeof e ? i(e, r, t) : "object" == typeof e ? n(e, r) : {};
    }

    function l(e) {
      return o(e.isSize);
    }

    function u(e) {
      return s(e);
    }

    function d(e) {
      return o(e.isOffset, !0);
    }

    function c(e) {
      e.isOffset;
      return f.__rest(e, ["isOffset"]);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });

    var f = t(0),
        v = t(1),
        _ = t(4),
        g = _.isBetween(1, 12),
        m = _.isOption(v.isMobile, v.isTablet, v.isTouch, v.isDesktop, v.isWidescreen, v.isFullHD);

    r.getGridSizesModifiers = a, r.removeGridSizesProps = s;
    var p = {
      "1/2": "half",
      "1/3": "one-third",
      "1/4": "one-quarter",
      "2/3": "two-thirds",
      "3/4": "three-quarters"
    },
        M = {
      full: "full",
      narrow: "narrow"
    };
    r.getSizeModifiers = l, r.removeSizeProps = u, r.getOffsetModifiers = d, r.removeOffsetProps = c;
  }, function (e, r, t) {
    e.exports = t(7);
  }, function (e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var a = t(8);
    r.Columns = a.default;
    var s = t(9);
    r.Column = s.default;
    var i = t(10);
    r.Tile = i.default;
    var n = t(11);
    r.Box = n.default;
    var o = t(12);
    r.Button = o.default;
    var l = t(13);
    r.Content = l.default;
    var u = t(14);
    r.Delete = u.default;
    var d = t(15);
    r.Icon = d.default;
    var c = t(16);
    r.Image = c.default;
    var f = t(17);
    r.Notification = f.default;
    var v = t(18);
    r.Progress = v.default;

    var _ = t(19);

    r.Table = _.default;
    var g = t(20);
    r.Tag = g.default;
    var m = t(21);
    r.Title = m.default;
    var p = t(22);
    r.Subtitle = p.default;
    var M = t(23);
    r.Heading = M.default;
    var b = t(24);
    r.Checkbox = b.default;
    var h = t(25);
    r.Control = h.default;
    var N = t(26);
    r.Help = N.default;
    var P = t(27);
    r.Input = P.default;
    var y = t(28);
    r.Label = y.default;
    var H = t(29);
    r.Radio = H.default;
    var w = t(30);
    r.Select = w.default;
    var O = t(31);
    r.TextArea = O.default;
    var j = t(32);
    r.Field = j.default;
    var E = t(33);
    r.FieldBody = E.default;
    var S = t(34);
    r.FieldLabel = S.default;
    var T = t(35);
    r.Breadcrumb = T.default;
    var L = t(36);
    r.BreadcrumbItem = L.default;
    var C = t(37);
    r.Card = C.default;
    var x = t(38);
    r.CardImage = x.default;
    var A = t(39);
    r.CardContent = A.default;
    var z = t(40);
    r.CardHeader = z.default;
    var B = t(41);
    r.CardHeaderTitle = B.default;
    var F = t(42);
    r.CardHeaderIcon = F.default;
    var k = t(43);
    r.CardFooter = k.default;
    var I = t(44);
    r.CardFooterItem = I.default;
    var D = t(45);
    r.Dropdown = D.default;
    var R = t(46);
    r.DropdownContent = R.default;
    var G = t(47);
    r.DropdownDivider = G.default;
    var W = t(48);
    r.DropdownItem = W.default;
    var V = t(49);
    r.DropdownMenu = V.default;
    var q = t(50);
    r.DropdownTrigger = q.default;
    var U = t(51);
    r.Level = U.default;
    var J = t(52);
    r.LevelItem = J.default;
    var K = t(53);
    r.LevelLeft = K.default;
    var Q = t(54);
    r.LevelRight = Q.default;
    var X = t(55);
    r.Media = X.default;
    var Y = t(56);
    r.MediaContent = Y.default;
    var Z = t(57);
    r.MediaLeft = Z.default;
    var $ = t(58);
    r.MediaRight = $.default;
    var ee = t(59);
    r.Menu = ee.default;
    var re = t(60);
    r.MenuLabel = re.default;
    var te = t(61);
    r.MenuList = te.default;
    var ae = t(62);
    r.MenuLink = ae.default;
    var se = t(63);
    r.Message = se.default;
    var ie = t(64);
    r.MessageHeader = ie.default;
    var ne = t(65);
    r.MessageBody = ne.default;
    var oe = t(66);
    r.Modal = oe.default;
    var le = t(67);
    r.ModalBackground = le.default;
    var ue = t(68);
    r.ModalContent = ue.default;
    var de = t(69);
    r.ModalClose = de.default;
    var ce = t(70);
    r.ModalCard = ce.default;
    var fe = t(71);
    r.ModalCardHeader = fe.default;
    var ve = t(72);
    r.ModalCardTitle = ve.default;

    var _e = t(73);

    r.ModalCardBody = _e.default;
    var ge = t(74);
    r.ModalCardFooter = ge.default;
    var me = t(75);
    r.Nav = me.default;
    var pe = t(76);
    r.NavLeft = pe.default;
    var Me = t(77);
    r.NavCenter = Me.default;
    var be = t(78);
    r.NavRight = be.default;
    var he = t(79);
    r.NavToggle = he.default;
    var Ne = t(80);
    r.NavItem = Ne.default;
    var Pe = t(81);
    r.Navbar = Pe.default;
    var ye = t(82);
    r.NavbarBrand = ye.default;
    var He = t(83);
    r.NavbarBurger = He.default;
    var we = t(84);
    r.NavbarMenu = we.default;
    var Oe = t(85);
    r.NavbarStart = Oe.default;
    var je = t(86);
    r.NavbarEnd = je.default;
    var Ee = t(87);
    r.NavbarItem = Ee.default;
    var Se = t(88);
    r.NavbarLink = Se.default;
    var Te = t(89);
    r.NavbarDropdown = Te.default;
    var Le = t(90);
    r.NavbarDivider = Le.default;
    var Ce = t(91);
    r.Pagination = Ce.default;
    var xe = t(92);
    r.PageControl = xe.default;
    var Ae = t(93);
    r.PageEllipsis = Ae.default;
    var ze = t(94);
    r.Page = ze.default;
    var Be = t(95);
    r.PageList = Be.default;
    var Fe = t(96);
    r.PageLink = Fe.default;
    var ke = t(97);
    r.Panel = ke.default;
    var Ie = t(98);
    r.PanelHeading = Ie.default;
    var De = t(99);
    r.PanelTabs = De.default;
    var Re = t(100);
    r.PanelTab = Re.default;
    var Ge = t(101);
    r.PanelBlock = Ge.default;
    var We = t(102);
    r.PanelIcon = We.default;
    var Ve = t(103);
    r.Tabs = Ve.default;
    var qe = t(104);
    r.Tab = qe.default;
    var Ue = t(105);
    r.TabList = Ue.default;
    var Je = t(106);
    r.TabLink = Je.default;
    var Ke = t(107);
    r.Container = Ke.default;
    var Qe = t(108);
    r.Footer = Qe.default;
    var Xe = t(109);
    r.Section = Xe.default;
    var Ye = t(110);
    r.Hero = Ye.default;
    var Ze = t(111);
    r.HeroHeader = Ze.default;
    var $e = t(112);
    r.HeroBody = $e.default;
    var er = t(113);
    r.HeroVideo = er.default;
    var rr = t(114);
    r.HeroFooter = rr.default;
    var tr = t(1);
    r.withHelpersModifiers = tr.withHelpersModifiers;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("columns", {
        "is-centered": a.isCentered,
        "is-desktop": a.isDesktop,
        "is-gapless": a.isGapless,
        "is-grid": a.isGrid,
        "is-mobile": a.isMobile,
        "is-multiline": a.isMultiline,
        "is-vcentered": a.isVCentered
      }, a.className),
          l = (a.isMobile, a.isDesktop, a.isGapless, a.isGrid, a.isMultiline, a.isVCentered, a.isCentered, s.__rest(a, ["isMobile", "isDesktop", "isGapless", "isGrid", "isMultiline", "isVCentered", "isCentered"]));

      return n.createElement(t, s.__assign({}, l, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Columns = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("column", s.__assign({}, l.combineModifiers(a, u.getSizeModifiers, u.getOffsetModifiers)), a.className),
          d = l.getHTMLProps(a, u.removeSizeProps, u.removeOffsetProps);

      return n.createElement(t, s.__assign({}, d, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = t(5);
    r.Column = a;
    var d = o.withHelpersModifiers(a);
    r.default = d;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.render,
          o = s.__rest(e, ["tag", "render"]),
          d = i("tile", s.__assign({
        "is-ancestor": o.isAncestor,
        "is-child": o.isChild,
        "is-parent": o.isParent,
        "is-vertical": o.isVertical
      }, u.getGridSizesModifiers(o.isSize)), o.className),
          c = (o.isAncestor, o.isChild, o.isParent, o.isVertical, s.__rest(o, ["isAncestor", "isChild", "isParent", "isVertical"])),
          f = l.getHTMLProps(c, u.removeGridSizesProps);

      return a ? a(s.__assign({}, f, {
        className: d
      })) : n.createElement(t, s.__assign({}, f, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = t(5);
    r.Tile = a;
    var d = o.withHelpersModifiers(a);
    r.default = d;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("box", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Box = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("button", s.__assign({
        "is-inverted": e.isInverted,
        "is-link": e.isLink,
        "is-outlined": e.isOutlined,
        "is-static": e.isStatic
      }, l.combineModifiers(e, o.getStateModifiers, o.getColorModifiers, o.getLoadingModifiers, o.getSizeModifiers)), e.className),
          t = e.render,
          a = (e.isLink, e.isOutlined, e.isInverted, e.isStatic, s.__rest(e, ["render", "isLink", "isOutlined", "isInverted", "isStatic"])),
          u = l.getHTMLProps(a, o.removeStateProps, o.removeColorProps, o.removeLoadingProps, o.removeSizeProps);
      if (t) return t(s.__assign({}, u, {
        className: r
      }));
      var d = n.createElement("a", s.__assign({}, u, {
        role: "button",
        className: r
      })),
          c = n.createElement("button", s.__assign({}, u, {
        type: e.type || "button",
        className: r
      }));
      return e.href ? d : c;
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Button = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("content", s.__assign({}, o.getSizeModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Content = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("delete", s.__assign({}, o.getSizeModifiers(e)), e.className),
          t = e.render,
          a = s.__rest(e, ["render"]),
          u = l.getHTMLProps(a, o.removeSizeProps);

      if (t) return t(s.__assign({}, u, {
        className: r
      }));
      var d = n.createElement("a", s.__assign({
        role: "button"
      }, u, {
        className: r
      })),
          c = n.createElement("button", s.__assign({
        type: e.type || "button"
      }, u, {
        className: r
      }));
      return e.href ? d : c;
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Delete = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r,
          t = (e.children, s.__rest(e, ["children"])),
          a = i("icon", s.__assign({}, u(t.isAlign) ? (r = {}, r["is-" + t.isAlign] = !0, r) : {}, o.getSizeModifiers(t))),
          d = l.getHTMLProps(t, o.removeAlignmentProps, o.removeSizeProps);
      return n.createElement("span", s.__assign({}, d, {
        className: a
      }), n.createElement("i", {
        className: "" + t.className,
        "aria-hidden": "true"
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = l.isOption(o.isLeft, o.isRight);
    r.Icon = a;
    var d = o.withHelpersModifiers(a);
    r.default = d;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r,
          t = e.isSize;
      return o.__assign({}, v(t) ? (r = {}, r["is-" + t] = !0, r) : {});
    }

    function s(e) {
      var r,
          t = e.isRatio;
      return o.__assign({}, f(t) ? (r = {}, r["is-" + f(t)] = !0, r) : {});
    }

    function i(e) {
      e.isSize, e.isRatio;
      return o.__rest(e, ["isSize", "isRatio"]);
    }

    function n(e) {
      var r = l("image", o.__assign({}, c.combineModifiers(e, a, s)), e.className),
          t = c.getHTMLProps(e, i),
          n = (t.children, t.src),
          d = o.__rest(t, ["children", "src"]);

      return u.createElement("figure", o.__assign({}, d, {
        className: r
      }), u.createElement("img", {
        src: n
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var o = t(0),
        l = t(3),
        u = t(2),
        d = t(1),
        c = t(4),
        f = c.is({
      "16:9": "16by9",
      "1:1": "1by1",
      "2:1": "2by1",
      "3:2": "3by2",
      "4:3": "4by3",
      square: "square"
    }),
        v = c.is({
      "128x128": !0,
      "16x16": !0,
      "24x24": !0,
      "32x32": !0,
      "48x48": !0,
      "64x64": !0,
      "96x96": !0
    });
    r.Image = n;

    var _ = d.withHelpersModifiers(n);

    r.default = _;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("notification", s.__assign({}, o.getColorModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeColorProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Notification = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "progress" : r,
          a = s.__rest(e, ["tag"]),
          u = i("progress", s.__assign({}, l.combineModifiers(a, o.getSizeModifiers, o.getColorModifiers)), a.className),
          d = l.getHTMLProps(a, o.removeSizeProps, o.removeColorProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Progress = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("table", {
        "is-bordered": e.isBordered,
        "is-narrow": e.isNarrow,
        "is-striped": e.isStriped
      }, e.className),
          t = (e.isBordered, e.isStriped, e.isNarrow, s.__rest(e, ["isBordered", "isStriped", "isNarrow"]));
      return n.createElement("table", s.__assign({}, t, {
        className: r
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Table = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "span" : r,
          a = s.__rest(e, ["tag"]),
          u = i("tag", s.__assign({}, l.combineModifiers(a, o.getColorModifiers, o.getSizeModifiers)), a.className),
          d = l.getHTMLProps(a, o.removeColorProps, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Tag = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "h1" : r,
          a = s.__rest(e, ["tag"]),
          u = i("title", s.__assign({}, o.getHeadingModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeHeadingProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Title = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "h2" : r,
          a = s.__rest(e, ["tag"]),
          u = i("subtitle", s.__assign({}, o.getHeadingModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeHeadingProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Subtitle = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "p" : r,
          a = s.__rest(e, ["tag"]),
          o = i("heading", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Heading = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("checkbox", e.className),
          t = e.children,
          a = (e.className, s.__rest(e, ["children", "className"]));
      return n.createElement("label", {
        className: r
      }, n.createElement("input", s.__assign({}, a, {
        type: "checkbox"
      })), t);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Checkbox = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("control", s.__assign({}, d(a.hasIcons), {
        "is-expanded": a.isExpanded
      }, o.getLoadingModifiers(a)), a.className),
          c = (a.hasIcons, a.isExpanded, s.__rest(a, ["hasIcons", "isExpanded"])),
          f = l.getHTMLProps(c, o.removeLoadingProps);

      return n.createElement(t, s.__assign({}, f, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });

    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = l.isOption(o.isLeft, o.isRight),
        d = function d(e) {
      var r;
      return !0 === e ? {
        "has-icons-left has-icons-right": !0
      } : "string" == typeof e ? u(e) ? (r = {}, r["has-icons-" + e] = !0, r) : {} : Array.isArray(e) ? e.map(function (e) {
        return e.toLowerCase().trim();
      }).reduce(function (e, r) {
        var t;
        return u(r) ? s.__assign({}, e, (t = {}, t["has-icons-" + r] = !0, t)) : e;
      }, {}) : {};
    };

    r.Control = a;
    var c = o.withHelpersModifiers(a);
    r.default = c;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "p" : r,
          a = s.__rest(e, ["tag"]),
          u = i("help", s.__assign({}, o.getColorModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeColorProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Help = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("input", s.__assign({}, l.combineModifiers(e, o.getColorModifiers, o.getSizeModifiers, o.getStateModifiers)), e.className),
          t = l.getHTMLProps(e, o.removeColorProps, o.removeSizeProps, o.removeStateProps);
      return n.createElement("input", s.__assign({}, t, {
        className: r,
        type: e.type || "text"
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Input = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("label", s.__assign({}, o.getSizeModifiers(e)), e.className),
          t = l.getHTMLProps(e, o.removeSizeProps);
      return n.createElement("label", s.__assign({}, t, {
        className: r
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Label = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("radio", e.className),
          t = e.children,
          a = (e.className, s.__rest(e, ["children", "className"]));
      return n.createElement("label", {
        className: r
      }, n.createElement("input", s.__assign({}, a, {
        type: "radio"
      })), t);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Radio = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("select", s.__assign({
        "is-disabled": e.disabled
      }, l.combineModifiers(e, o.getColorModifiers, o.getSizeModifiers, o.getLoadingModifiers)), e.className),
          t = l.getHTMLProps(e, o.removeColorProps, o.removeSizeProps, o.removeLoadingProps),
          a = t.children,
          u = (t.className, s.__rest(t, ["children", "className"]));
      return n.createElement("div", {
        className: r
      }, n.createElement("select", s.__assign({}, u), a));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Select = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = i("textarea", s.__assign({}, l.combineModifiers(e, o.getSizeModifiers, o.getStateModifiers)), e.className),
          t = l.getHTMLProps(e, o.removeSizeProps, o.removeStateProps);
      return n.createElement("textarea", s.__assign({}, t, {
        className: r
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.TextArea = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          d = i("field", s.__assign({}, u(a.isGrouped, "is-grouped", l.isOption(o.isRight, o.isCentered)), u(a.hasAddons, "has-addons", l.isOption(o.isRight, o.isCentered, o.isFullWidth)), {
        "is-horizontal": a.isHorizontal
      }), a.className),
          c = (a.isGrouped, a.hasAddons, a.isHorizontal, s.__rest(a, ["isGrouped", "hasAddons", "isHorizontal"]));

      return n.createElement(t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });

    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = function u(e, r, t) {
      var a, s;
      return !0 === e ? (a = {}, a["" + r] = !0, a) : "string" == typeof e && t(e) ? (s = {}, s[r + " " + r + "-" + e] = !0, s) : {};
    };

    r.Field = a;
    var d = o.withHelpersModifiers(a);
    r.default = d;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("field-body", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.FieldBody = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("field-label", s.__assign({
        "is-normal": a.isNormal
      }, o.getSizeModifiers(a)), a.className),
          d = (a.isNormal, s.__rest(a, ["isNormal"])),
          c = l.getHTMLProps(d, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.FieldLabel = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "nav" : r,
          a = e.hasSeparator,
          d = s.__rest(e, ["tag", "hasSeparator"]),
          c = i("breadcrumb", s.__assign({}, u(a), l.combineModifiers(d, o.getAlignmentModifiers, o.getSizeModifiers)), d.className),
          f = l.getHTMLProps(d, o.removeAlignmentProps, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, f, {
        className: c
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });

    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = function u(e) {
      var r;
      return e ? (r = {}, r["has-" + e + "-separator"] = !0, r) : {};
    };

    r.Breadcrumb = a;
    var d = o.withHelpersModifiers(a);
    r.default = d;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "li" : r,
          a = s.__rest(e, ["tag"]),
          u = i(s.__assign({}, o.getActiveModifiers(a)), a.className) || void 0,
          d = l.getHTMLProps(a, o.removeActiveModifiers);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.BreadcrumbItem = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("card", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Card = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("card-image", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.CardImage = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("card-content", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.CardContent = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "header" : r,
          a = s.__rest(e, ["tag"]),
          o = n("card-header", a.className);

      return i.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(2),
        n = t(3),
        o = t(1);
    r.CardHeader = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "p" : r,
          a = s.__rest(e, ["tag"]),
          o = n("card-header-title", a.className);

      return i.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(2),
        n = t(3),
        o = t(1);
    r.CardHeaderTitle = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          o = s.__rest(e, ["tag", "render"]),
          l = n("card-header-icon", o.className);

      return a ? a(s.__assign({}, o, {
        className: l
      })) : i.createElement(t, s.__assign({}, o, {
        className: l
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(2),
        n = t(3),
        o = t(1);
    r.CardHeaderIcon = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "footer" : r,
          a = s.__rest(e, ["tag"]),
          o = i("card-footer", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.CardFooter = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "p" : r,
          a = e.render,
          o = s.__rest(e, ["tag", "render"]),
          l = i("card-footer-item", o.className);

      return a ? a(s.__assign({}, o, {
        className: l
      })) : n.createElement(o.href ? "a" : t, s.__assign({}, o, {
        className: l
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.CardFooterItem = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.isHoverable,
          u = s.__rest(e, ["tag", "isHoverable"]),
          d = i("dropdown", s.__assign({
        "is-hoverable": a
      }, l.combineModifiers(u, o.getActiveModifiers, o.getAlignmentModifiers)), u.className),
          c = l.getHTMLProps(u, o.removeActiveModifiers, o.removeAlignmentProps);

      return n.createElement(t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Dropdown = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("dropdown-content", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.DropdownContent = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "hr" : r,
          a = s.__rest(e, ["tag"]),
          o = i("dropdown-divider", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.DropdownDivider = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i("dropdown-item", s.__assign({}, o.getActiveModifiers(u)), u.className),
          c = l.getHTMLProps(u, o.removeActiveModifiers);

      return a ? a(s.__assign({}, c, {
        className: d
      })) : n.createElement(u.href ? "a" : t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.DropdownItem = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = s.__rest(e, []),
          t = i("dropdown-menu", r.className);

      return n.createElement("div", s.__assign({}, r, {
        className: t
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.DropdownMenu = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("dropdown-trigger", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.DropdownTrigger = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "nav" : r,
          a = s.__rest(e, ["tag"]),
          o = i("level", {
        "is-mobile": a.isMobile
      }, a.className),
          l = (a.isMobile, s.__rest(a, ["isMobile"]));

      return n.createElement(t, s.__assign({}, l, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Level = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("level-item", {
        "is-flexible": a.isFlexible
      }, a.className),
          l = (a.isFlexible, s.__rest(a, ["isFlexible"]));

      return n.createElement(a.href ? "a" : t, s.__assign({}, l, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.LevelItem = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("level-left", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.LevelLeft = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("level-right", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.LevelRight = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "article" : r,
          a = s.__rest(e, ["tag"]),
          u = i("media", s.__assign({}, o.getSizeModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Media = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("media-content", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MediaContent = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("media-left", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MediaLeft = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("media-right", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MediaRight = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "aside" : r,
          a = s.__rest(e, ["tag"]),
          o = i("menu", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Menu = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "p" : r,
          a = s.__rest(e, ["tag"]),
          o = i("menu-label", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MenuLabel = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "ul" : r,
          a = s.__rest(e, ["tag"]),
          o = i("menu-list", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MenuList = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i(s.__assign({}, o.getActiveModifiers(u)), u.className) || void 0,
          c = l.getHTMLProps(u, o.removeActiveModifiers);

      return a ? a(s.__assign({}, c, {
        className: d
      })) : n.createElement(t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.MenuLink = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "article" : r,
          a = s.__rest(e, ["tag"]),
          u = i("message", s.__assign({}, o.getColorModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeColorProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Message = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("message-header", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MessageHeader = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("message-body", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.MessageBody = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("modal", s.__assign({}, o.getActiveModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeActiveModifiers);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Modal = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-background", a.className);

      a.children, s.__rest(a, ["children"]);
      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalBackground = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-content", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalContent = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "button" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i("modal-close", s.__assign({}, o.getSizeModifiers(u)), u.className),
          c = l.getHTMLProps(u, o.removeSizeProps);

      return a ? a(s.__assign({}, c, {
        className: d
      })) : n.createElement(t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.ModalClose = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-card", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalCard = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "header" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-card-head", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalCardHeader = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "h1" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-card-title", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalCardTitle = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "section" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-card-body", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalCardBody = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "footer" : r,
          a = s.__rest(e, ["tag"]),
          o = i("modal-card-foot", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.ModalCardFooter = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "nav" : r,
          a = s.__rest(e, ["tag"]),
          o = i("nav", {
        "has-shadow": a.hasShadow
      }, a.className),
          l = (a.hasShadow, s.__rest(a, ["hasShadow"]));

      return n.createElement(t, s.__assign({}, l, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Nav = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("nav-left", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavLeft = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("nav-center", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavCenter = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("nav-right", s.__assign({
        "nav-menu": a.isMenu
      }, o.getActiveModifiers(a)), a.className),
          d = (a.isMenu, s.__rest(a, ["isMenu"])),
          c = l.getHTMLProps(d, o.removeActiveModifiers);

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavRight = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "span" : r,
          a = s.__rest(e, ["tag"]),
          u = i("nav-toggle", s.__assign({}, o.getActiveModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeActiveModifiers),
          c = (d.children, s.__rest(d, ["children"]));

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }), n.createElement("span", null), n.createElement("span", null), n.createElement("span", null));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavToggle = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i("nav-item", s.__assign({
        "is-brand": u.isBrand,
        "is-tab": u.isTab
      }, o.getActiveModifiers(u)), u.className),
          c = (u.isTab, u.isBrand, s.__rest(u, ["isTab", "isBrand"])),
          f = l.getHTMLProps(c, o.removeActiveModifiers);

      return a ? a(s.__assign({}, f, {
        className: d
      })) : n.createElement(u.href ? "a" : t, s.__assign({}, f, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavItem = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "nav" : r,
          a = e.isTransparent,
          o = s.__rest(e, ["tag", "isTransparent"]),
          l = i("navbar", {
        "is-transparent": a
      }, o.className);

      return n.createElement(t, s.__assign({}, o, {
        className: l
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Navbar = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("navbar-brand", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavbarBrand = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("navbar-burger", s.__assign({}, o.getActiveModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeActiveModifiers),
          c = (d.children, s.__rest(d, ["children"]));

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }), n.createElement("span", null), n.createElement("span", null), n.createElement("span", null));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavbarBurger = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("navbar-menu", s.__assign({}, o.getActiveModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeActiveModifiers);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavbarMenu = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("navbar-start", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavbarStart = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("navbar-end", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavbarEnd = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.render,
          u = e.isHoverable,
          d = e.hasDropdown,
          c = s.__rest(e, ["tag", "render", "isHoverable", "hasDropdown"]),
          f = i("navbar-item", s.__assign({
        "has-dropdown": d,
        "is-hoverable": u
      }, o.getActiveModifiers(c)), c.className),
          v = l.getHTMLProps(c, o.removeActiveModifiers);

      return a ? a(s.__assign({}, v, {
        className: f
      })) : n.createElement(c.href ? "a" : t, s.__assign({}, v, {
        className: f
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavbarItem = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i("navbar-link", s.__assign({}, o.getActiveModifiers(u)), u.className);

      if (a) return a(s.__assign({}, u, {
        className: d
      }));
      var c = l.getHTMLProps(u, o.removeActiveModifiers);
      return n.createElement(t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.NavbarLink = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.isBoxed,
          o = s.__rest(e, ["tag", "isBoxed"]),
          l = i("navbar-dropdown", {
        "is-boxed": a
      }, o.className);

      return n.createElement(t, s.__assign({}, o, {
        className: l
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavbarDropdown = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "hr" : r,
          a = (e.isBoxed, s.__rest(e, ["tag", "isBoxed"])),
          o = i("navbar-divider", a.className);
      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.NavbarDivider = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "nav" : r,
          a = s.__rest(e, ["tag"]),
          u = i("pagination", s.__assign({}, l.combineModifiers(a, o.getAlignmentModifiers, o.getSizeModifiers)), a.className),
          d = l.getHTMLProps(a, o.removeAlignmentProps, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Pagination = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i(s.__assign({
        "pagination-next": !u.isPrevious && u.isNext,
        "pagination-previous": !u.isNext
      }, l.combineModifiers(u, o.getActiveModifiers, o.getFocusedModifiers)), u.className),
          c = (u.isNext, u.isPrevious, s.__rest(u, ["isNext", "isPrevious"])),
          f = l.getHTMLProps(c, o.removeActiveModifiers, o.removeFocusedModifiers);

      return a ? a(s.__assign({}, f, {
        className: d
      })) : n.createElement(t, s.__assign({}, f, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.PageControl = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "span" : r,
          a = s.__rest(e, ["tag"]),
          u = i("pagination-ellipsis", s.__assign({}, l.combineModifiers(a, o.getActiveModifiers, o.getFocusedModifiers)), a.className),
          d = l.getHTMLProps(a, o.removeActiveModifiers, o.removeFocusedModifiers),
          c = (d.children, s.__rest(d, ["children"]));

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }), "…");
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Ellipsis = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "li" : r,
          a = s.__rest(e, ["tag"]);

      return i.createElement(t, a);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(2),
        n = t(1);
    r.Page = a;
    var o = n.withHelpersModifiers(a);
    r.default = o;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "ul" : r,
          a = s.__rest(e, ["tag"]),
          o = i("pagination-list", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.PageList = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i("pagination-link", s.__assign({
        "is-current": u.isCurrent
      }, l.combineModifiers(u, o.getActiveModifiers, o.getFocusedModifiers)), u.className),
          c = (u.isCurrent, s.__rest(u, ["isCurrent"])),
          f = l.getHTMLProps(c, o.removeActiveModifiers, o.removeFocusedModifiers);

      return a ? a(s.__assign({}, f, {
        className: d
      })) : n.createElement(t, s.__assign({}, f, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.PageLink = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "nav" : r,
          a = s.__rest(e, ["tag"]),
          o = i("panel", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Panel = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "p" : r,
          a = s.__rest(e, ["tag"]),
          o = i("panel-heading", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.PanelHeading = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("panel-tabs", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.PanelTabs = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i(s.__assign({}, o.getActiveModifiers(u)), u.className) || void 0,
          c = l.getHTMLProps(u, o.removeActiveModifiers);

      return a ? a(s.__assign({}, c, {
        className: d
      })) : n.createElement(t, s.__assign({}, c, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.PanelTab = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = e.render,
          u = s.__rest(e, ["tag", "render"]),
          d = i("panel-block", s.__assign({
        "is-wrapped": u.isWrapped
      }, o.getActiveModifiers(u)), u.className),
          c = (u.isWrapped, s.__rest(u, ["isWrapped"])),
          f = l.getHTMLProps(c, o.removeActiveModifiers);

      return a ? a(s.__assign({}, f, {
        className: d
      })) : n.createElement(u.href ? "a" : t, s.__assign({}, f, {
        className: d
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.PanelBlock = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = (e.children, s.__rest(e, ["children"]));
      return i.createElement("span", s.__assign({}, r, {
        className: "panel-icon"
      }), i.createElement("i", {
        className: "" + r.className,
        "aria-hidden": "true"
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(2),
        n = t(1);
    r.PanelIcon = a;
    var o = n.withHelpersModifiers(a);
    r.default = o;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          u = i("tabs", s.__assign({
        "is-boxed": a.isBoxed,
        "is-toggle": a.isToggle
      }, l.combineModifiers(a, o.getAlignmentModifiers, o.getSizeModifiers)), a.className),
          d = (a.isBoxed, a.isToggle, s.__rest(a, ["isBoxed", "isToggle"])),
          c = l.getHTMLProps(d, o.removeAlignmentProps, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Tabs = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "li" : r,
          a = s.__rest(e, ["tag"]),
          u = i(s.__assign({}, o.getActiveModifiers(a)), a.className) || void 0,
          d = l.getHTMLProps(a, o.removeActiveModifiers);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Tab = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r,
          t = e.tag,
          a = void 0 === t ? "ul" : t,
          d = s.__rest(e, ["tag"]),
          c = i(s.__assign({}, u(d.isAlign) ? (r = {}, r["is-" + d.isAlign] = !0, r) : {}), d.className) || void 0,
          f = l.getHTMLProps(d, o.removeAlignmentProps);

      return n.createElement(a, s.__assign({}, f, {
        className: c
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4),
        u = l.isOption(o.isLeft, o.isCenter, o.isRight);
    r.TabList = a;
    var d = o.withHelpersModifiers(a);
    r.default = d;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "a" : r,
          a = e.render,
          n = s.__rest(e, ["tag", "render"]);

      return a ? a(s.__assign({}, n)) : i.createElement(t, n);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(2),
        n = t(1);
    r.TabLink = a;
    var o = n.withHelpersModifiers(a);
    r.default = o;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("container", {
        "is-fluid": a.isFluid
      }, a.className),
          l = (a.isFluid, s.__rest(a, ["isFluid"]));

      return n.createElement(t, s.__assign({}, l, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Container = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "footer" : r,
          a = s.__rest(e, ["tag"]),
          o = i("footer", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.Footer = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "section" : r,
          a = s.__rest(e, ["tag"]),
          u = i("section", s.__assign({}, o.getSizeModifiers(a)), a.className),
          d = l.getHTMLProps(a, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, d, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Section = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "section" : r,
          a = s.__rest(e, ["tag"]),
          u = i("hero", s.__assign({
        "is-bold": a.isBold,
        "is-fullheight": a.isFullHeight,
        "is-halfheight": a.isHalfHeight
      }, l.combineModifiers(a, o.getColorModifiers, o.getSizeModifiers)), a.className),
          d = (a.isBold, a.isFullHeight, s.__rest(a, ["isBold", "isFullHeight"])),
          c = l.getHTMLProps(d, o.removeColorProps, o.removeSizeProps);

      return n.createElement(t, s.__assign({}, c, {
        className: u
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1),
        l = t(4);
    r.Hero = a;
    var u = o.withHelpersModifiers(a);
    r.default = u;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "header" : r,
          a = s.__rest(e, ["tag"]),
          o = i("hero-head", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.HeroHeader = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("hero-body", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.HeroBody = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "div" : r,
          a = s.__rest(e, ["tag"]),
          o = i("hero-video", {
        "is-transparent": a.isTransparent
      }, a.className),
          l = (a.isTransparent, s.__rest(a, ["isTransparent"]));

      return n.createElement(t, s.__assign({}, l, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.HeroVideo = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }, function (e, r, t) {
    "use strict";

    function a(e) {
      var r = e.tag,
          t = void 0 === r ? "footer" : r,
          a = s.__rest(e, ["tag"]),
          o = i("hero-foot", a.className);

      return n.createElement(t, s.__assign({}, a, {
        className: o
      }));
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    var s = t(0),
        i = t(3),
        n = t(2),
        o = t(1);
    r.HeroFooter = a;
    var l = o.withHelpersModifiers(a);
    r.default = l;
  }]);
});